export default __webpack_public_path__ + "54b852caf0a7a8cc598c0a32be7e9c5f.svg";